import {Permissions as P} from '@myfm/domain';
import {Link,useLocation} from 'react-router';
import {useAuth} from '../auth';
import {administrationSections} from '../views/administration-sections';
import {useStaffSession} from './StaffSession';
import {Icon,navigationIcon} from './Icon';
import {featureWorkspaceLinks,featureWorkspacePage} from './feature-workspace-navigation';
import {WorkspaceMoreLinks} from './WorkspaceMoreLinks';
export const administrationWorkspacePath=(path:string)=>path==='/admin'||path.startsWith('/admin/')||path==='/audit'||path==='/approvals'||path==='/operating-appointments'||path==='/pilot-onboarding'||path.startsWith('/pilot-onboarding/')||featureWorkspacePage(path)?.workspace==='administration';
export function AdministrationWorkspaceRail(){
 const location=useLocation(),session=useStaffSession()!,auth=useAuth();
 if(!administrationWorkspacePath(location.pathname))return null;
 const tools=[...administrationSections(session.capabilities,auth.config??{}).flatMap(section=>section.tools),
 ...featureWorkspaceLinks(session,'administration',auth.config?.alphaFeaturesEnabled===true,location.pathname).map(item=>({title:item.label,href:item.href}))];
 const candidates=[
 {title:'Overview',href:'/admin',allowed:session.capabilities.includes(P.ViewAdministration)},
 {title:'People & access',href:'/admin/access/staff'},
 {title:'Automation',href:'/admin/automation'},
 {title:'Connections',href:'/admin/mail/services'},
 {title:'Change approvals',href:'/approvals',allowed:session.capabilities.includes(P.ApproveProposal)},
 {title:'Classification',href:'/admin/classifications'},
 {title:'Audit history',href:'/audit'},
 {title:'Recycle bin',href:'/admin/recycle-bin'},
 ];
 const items=candidates.filter(item=>item.allowed??tools.some(tool=>tool.href===item.href));
 const used=new Set(items.map(item=>item.href)),extras=tools.filter(tool=>!used.has(tool.href));
 const pathname=(href:string)=>new URL(href,'https://staff.invalid').pathname;
 const selected=[...items,...extras].filter(item=>{
  const path=pathname(item.href);return location.pathname===path||path!=='/admin'&&location.pathname.startsWith(path+'/');
 }).sort((a,b)=>pathname(b.href).length-pathname(a.href).length)[0];
 return <nav className="workspace-family-navigation administration-family-navigation" aria-label="Administration navigation"><ul>{items.map(item=><li key={item.href}><Link to={item.href} aria-current={selected?.href===item.href?'page':undefined}><Icon name={navigationIcon(item.title)}/><span>{item.title}</span></Link></li>)}</ul>
 <WorkspaceMoreLinks items={extras.map(item=>({href:item.href,label:item.title}))} isCurrent={item=>selected?.href===item.href} summary="More settings"/>
 </nav>;
}
